module.exports = __webpack_public_path__ + "static/img/20211211_1.d2de652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211211_1.png
// module id = 0c6B
// module chunks = 0